export default "__VITE_ASSET__B2N0uaYJ__"